<template>
    <div class="pay-situation-detail-container">
        <div class="content">
            <mobile-card :show-footer="true">
                <template slot="title">{{title}}</template>

                <template slot="content" v-if="detail">
                    <!-- 应交部分 -->
                    <div v-if="$utils.isNotEmpty(detail.needAllMoney) || $utils.isNotEmpty(detail.needMoney)">
                        <div class="flex-form-info" v-if="$utils.isNotEmpty(detail.needMoney)">
                            <span>应交</span>
                            <span>{{detail.needMoney | formatMoney}}</span>
                        </div>

                        <div class="flex-form-info" v-if="$utils.isNotEmpty(detail.disCountMoney)">
                            <span>减免</span>
                            <span>{{detail.disCountMoney | formatMoney}}</span>
                        </div>

                        <div class="flex-form-info" v-if="$utils.isNotEmpty(detail.delayMoney)">
                            <span>缓交</span>
                            <span>{{ `${detail.delayExpire}到期` }}</span>
                            <span>{{item.delayMoney | formatMoney}}</span>
                        </div>

                        <div v-if="$utils.isNotEmpty(detail.reditVos)">
                            <div class="flex-form-info" v-for="(item, index) in detail.laterVos" :key="index">
                                <span>贷款</span>
                                <span>{{item.typeName}}</span>
                                <span>{{item.money | formatMoney}}</span>
                            </div>
                        </div>

                        <div class="mobile-card-line van-hairline--top"></div>
                        <div class="flex-form-sum sum-text">
                            <span>当前应交合计</span>
                            <span>{{ detail.needAllMoney | formatMoney}}</span>
                        </div>
                    </div>

                    <!-- 已交部分 -->
                    <div>
                        <div v-if="$utils.isNotEmpty(detail.payRecordVOS)">
                            <div class="flex-form-info" v-for="(item, index) in detail.payRecordVOS" :key="index">
                                <span>{{ item.payTypeName}}</span>
                                <span>{{getPayTicketText(item)}}</span>
                                <span>{{item.payMoney | formatMoney}}</span>
                            </div>
                        </div>

                        <div v-if="$utils.isNotEmpty(detail.deductionVos)">
                            <div class="flex-form-info" v-for="(item, index) in detail.deductionVos" :key="index">
                                <span>抵扣</span>
                                <span>{{ getDeductionText(item) }}</span>
                                <span>{{ item.money | formatMoney }}</span>
                            </div>
                        </div>

                        <div class="mobile-card-line van-hairline--top"></div>
                        <div class="flex-form-sum sum-text">
                            <span>已交合计</span>
                            <span>{{ detail.alreadymoney | formatMoney }}</span>
                        </div>
                    </div>
                </template>

                <template slot="footer" v-if="nowMoneyShowed">
                    <div class="flex-form-sum sum-text">
                        <span>当前需交</span>
                        <span>{{ detail.nowMoney | formatMoney }}</span>
                    </div>
                </template>
            </mobile-card>
        </div>
        <div class="footer">
            <div class="footer-bar">
                <mobile-button color="#005423" @click="onBack">返回上一级</mobile-button>
            </div>
        </div>
    </div>
</template>

<script>
    import storage from 'good-storage'
    import MobileCard from "components/mobile-card/index";
    import apiPaySituation from "api/pay-situation";
    import MobileButton from "components/mobile-button/index";
    import utils from "@/utils/util";

    export default {
        name:'paySituationDetail',
        components: { MobileButton, MobileCard },

        data() {
            return {
                payItem: {},
                detail: {},
                title: "",
                nowMoneyShowed:true,
            };
        },

        activated() {
            this.getPayItem();
        },

        methods: {
            getPayItem() {
                let vue=this
                let payItem = storage.session.get("pay-item",{});
                this.payItem = payItem;
                let param = {
                    arrearId: payItem.arrearId,
                    orderNo: payItem.orderNo
                };
                apiPaySituation.detail(param).then(res => {
                    vue.detail = res.data || {};
                    if (utils.isNotEmpty(vue.detail.intervalName)) {
                        vue.title = `${vue.detail.intervalName}${vue.detail.itemName}`;
                    } else {
                        vue.title = this.detail.itemName;
                    }

                    // 应收计入待追缴 显示当前应交 + 已交 + 当前需交
                    vue.nowMoneyShowed = param.arrearId != null && vue.detail.isPursued === 1
                });
            },

            getLastText(item) {
                return `${item.time}到期`;
            },

            getPayTicketText(item) {
                let s = ''
                if (item.payTime) {
                    s = `${item.payTime}  `
                    if (item.ticketNum) {
                        let s2 = `票据号：${ item.ticketNum }`
                        s += s2
                    }
                } else {
                    if (item.ticketNum) {
                        let s2 = `票据号：${ item.ticketNum }`
                        s += s2
                    }
                }
                return s
            },

            getDeductionText(item) {
                let s = ''
                if (item.time) {
                    s = `${item.time}  `
                    if (item.typeName) {
                        let s2 = `${ item.typeName }`
                        s += s2
                    }
                } else {
                    if (item.typeName) {
                        let s2 = `${ item.typeName }`
                        s += s2
                    }
                }
                return s
            },

            onBack() {
                this.$router.back();
            }
        },
    };
</script>

<style lang='scss' scoped>
</style>
